import { render } from "./UIToast.vue?vue&type=template&id=207ab83a&scoped=true"
import script from "./UIToast.vue?vue&type=script&lang=js"
export * from "./UIToast.vue?vue&type=script&lang=js"

import "./UIToast.vue?vue&type=style&index=0&id=207ab83a&scoped=true&lang=css"

import exportComponent from "/root/app/github/pehuen-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-207ab83a"]])

export default __exports__